export default __webpack_public_path__ + "static/media/101.ba107f9c.jpg";